import React from 'react';
import { useSelector } from 'react-redux';
import { Route, Switch, Redirect } from 'react-router-dom';

import { getDivestitureDiagnosticResults } from '../../../../features/divestitureDiagnostic/divestitureDiagnosticSlice';
import {
  categoryPathRoute,
  formatCategoryPathRoute,
} from '../../../../features/divestitureDiagnostic/routes';
import DivestitureDiagnosticResults from '../DivestitureDiagnosticResults';

const Category = () => {
  const results = useSelector(getDivestitureDiagnosticResults);

  const renderResults = ({ match }) => {
    const allCategories = [results.overallDealComplexity, ...results.data];
    const category = allCategories.find(
      (c) => c.path === match.params.categoryPath
    );
    return category && <DivestitureDiagnosticResults category={category} />;
  };

  const renderComplexityOverview = ({ match }) => {
    const { projectId } = match.params;
    const overallComplexityPath = results.overallDealComplexity.path;
    return (
      <Redirect
        to={formatCategoryPathRoute(projectId, overallComplexityPath)}
      />
    );
  };

  return (
    <Switch>
      <Route path={categoryPathRoute} render={renderResults} />
      <Route render={renderComplexityOverview} />
    </Switch>
  );
};

export default Category;
